<template>
    <div class="section-one">
        <div class="hero container-fluid bg-white h-100 d-flex justify-content-center">
            <div class="row m-0 p-3">
                <div class="col-sm-12 col-md-6 d-flex align-items-center justify-content-end">
                    <img class="img-fluid" src="https://imonggocloudfrontcdn1.imonggo.com/wp-content/uploads/2020/08/ImonggoHeader082710.png" width="622" height="575" alt="">
                </div>
                <div class="sign-up-part col-sm-12 col-md-6">
                    <div class="row sign-up">
                        <div class="col">
                            <div class="card inner-div" >
                                <div class="logo-div mt-4">
                                    <img class="img-fluid d-block mx-auto" src="https://imonggocloudfrontcdn1.imonggo.com/wp-content/uploads/2019/09/imonggo-full-logo-hi-res-800x152.png" width="290" height="55" alt="">
                                </div>
                                <div class="card-body p-0 px-2">
                                    <div class="">
                                        <h4 class="card-title text-center">Trusted point-of-sale by SMEs.</h4>
                                    </div>
                                    <form action="" class="px-4">
                                        <div>
                                            <base-input placeholder="Email" type="email" v-model="email" input-classes="form-control" required/>
                                        </div>
                                        <div class="password">
                                            <base-input placeholder="Password" type="password" v-model="password" input-classes="form-control" required/> 
                                            <i class="show far fa-eye"></i>
                                        </div>
                                        <div>
                                            <base-button class="btn-create">Create Free Account</base-button>
                                        </div>

                                        <div class="separator">
                                            <div class="line"></div>
                                            <span class="p-2 text-black"><b> Or continue with </b> </span>
                                            <div class="line"></div>
                                        </div>

                                        <div class="my-3 d-flex justify-content-center">
                                            <base-button class="text-white btn-social-facebook" style="background-color: #3b5998" @click.prevent="loginWithFacebook"> <i class="fab fa-facebook-square m-0"></i> <span>Facebook</span> </base-button>
                                            <base-button class="bg-white btn-social-google text-gray"> <i class="fab fa-google m-0" @click.prevent="loginWithGoogle"></i> <span>Google</span> </base-button>
                                            <base-button class="bg-dark btn-social-apple text-white"> <i class="fab fa-apple m-0"></i> <span>Apple</span> </base-button>
                                        </div>

                                         <div>
                                            <p class="p-text">By continuing, you are indicating that you accept our <a href="">Terms of Service</a> and <a href="">Privacy Policy</a>.</p>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseInput from '../../components/BaseInput.vue';
import ValidateField from '../../components/validateFormUtils';
import HTTPRequest from '../../controllers/httpRequest';


export default{
  components: { BaseInput },
    computed: {
        ...mapState(['endPoint'])
    },
    data(){
        return{
            errors: [],
            email: '',
            password: '',
        }
    },
    methods:{
    async createAccount(){
       

        var valid = true;
        this.errors = [];
        this.errors.push(ValidateField.required('Email address', this.email));
        this.errors.push(ValidateField.required('Password', this.password));

        this.errors = this._.compact(this.errors);
        if(this.errors > 0){
            var errorText = '';
            for(var a=0; a < this.errors.length; a++){
                errorText += " " + this.errors[a]  + "."
            }
            this.$notification['error']({
                message: 'Missing required fields',
                description: errorText
            });
            valid = false;
        }
        if(valid){
            var accountPayload = {
                    user: {
                        email: this.email,
                        password: this.password
                    }
            }
            var accountRequest = await HTTPRequest.postRequest(this.endPoint + '/accounts/new_account_from_signup', null, accountPayload)
            if(accountRequest.error != undefined){
                    this.$notification['error']({
                        message: 'Failed to create account.',
                        description: accountRequest.error
                    });
                } else {
                    this.$notification['success']({
                        message: 'Successfully created account.',
                        description: "View account details for owner's login credentials"
                    });
                }
        }

    }
   },
    
}


</script>

<style scoped>
.row{
    height: 100%;
}
.sign-up{
    display: flex;
    align-items: center;
    height: 100%;
    width: 80%;
    
}
.section-one{
    height: 88vh;
}

.password{
    position: relative;
    display: block;
}
.show{
    position: absolute;
    top: 15px;
    right: 12px;
}
.separator{
    display: flex;
    align-items: center;
    font-size: 13px;
    padding: 8px 0;
    height: 10px;
    position: relative;
    margin-top: 15px;
    margin-bottom: 15px;
 

}
.line{
    height: 1px;
    flex: 1;
    background-color: #696969;
    margin: 10px;
    /* position: absolute; */
}
.btn-social-facebook,
.btn-social-google,
.btn-social-apple{
    border: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    font-size: 13px;   
    margin: 5px;
    padding-right: 10px;
    padding-left: 10px;
}
.btn-social-facebook{
    width: 120px;
}
.btn-social-google{
    width: 105px;
}
.btn-social-apple{
    width: 90px;
}
.btn-create{
    width: 100%;
    background-color: rgba(241,90,35,1);
    border: none;
    /* font-family:  Arial, Helvetica, sans-serif;
    letter-spacing: 2px;
    border-radius: 10px;
    
    font-weight: 100; */

}
.fa-google {
  background: conic-gradient(from -45deg, #ea4335 110deg, #4285f4 90deg 180deg, #34a853 180deg 270deg, #fbbc05 270deg) 73% 55%/150% 150% no-repeat;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
}
.fa-google, .fa-facebook-square, .fa-apple{
    font-size: 18px;
}
.p-text{
    font-size: 12px;
    color: #757575;
    /* font-weight: bold; */
    text-align: center;
    padding: 8px;
}
.inner-div{
    background-color: rgba(234,234,234,0.54);
    border: none;
    border-radius: 15px;

    
}
.sign-up-part{
    display: flex;
    justify-content: start;
}

@media (max-width: 767.98px){
    .section-one{
        height: auto;
    }
    .sign-up-part{
    justify-content: center;
    }
    .sign-up{
        width: 100%;
        justify-content: center;
    }
}
@media (min-width: 768px) and (max-width: 979px) {
    .hero{
        width: 100%;
    }
    .sign-up-part{
    justify-content: center;
    }
    .sign-up{
        width: 100%;
        justify-content: center;
    }
    .btn-social-facebook,
    .btn-social-google,
    .btn-social-apple{
       
        justify-content: center;
        
    }
    .fa-facebook-square,
    .fa-google,
    .fa-apple{
        display: none;
        
    }
    
}
@media (min-width: 978px) and (max-width: 1024px) {
    .hero{
        width: 100%;
    }
    .sign-up-part{
    justify-content: center;
    }
    .sign-up{
        width: 100%;
        justify-content: center;
    }
   
    
}
</style>
